// features/product/productSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { PRODUCTS } from './PRODUCTS';

const initialState = {
  logos: [],
  colors: [],
  pattern: [],
  product: {},
  products: PRODUCTS,
};

const productSlice = createSlice({
  name: 'product',
  initialState,
  reducers: {
    setProducts(state, action) {
      state.products = action.payload;
    },
    setProduct(state, action) {
      state.product = action.payload;
    },
    setLogos(state, action) {
      state.logos = action.payload;
    },
    setPattern(state, action) {
      state.pattern = action.payload;
    },
    setColors(state, action) {
      state.colors = action.payload;
    },
    addLogo(state, action) {
      state.logos.push(action.payload);
    },
    addColor(state, action) {
      state.colors.push(action.payload);
    },
    addPattern(state, action) {
      state.pattern.push(action.payload);
    },
    resetSelections(state) {
      state.logos = [];
      state.colors = [];
      state.pattern = [];
      state.product = {};
    },
  },
});

export const {
  setProducts,
  setProduct,
  setPattern,
  setLogos,
  setColors,
  addLogo,
  addColor,
  addPattern,
  resetSelections,
} = productSlice.actions;

export default productSlice.reducer;
